<template>
    <div class="modal fade"  id="json_modal"  tabindex="-1"  role="dialog">
        <div class="modal-dialog mx-auto" role="document" style="min-width:50% !important;">
            <div class="modal-content"  style='overflow:hidden;'>
                <div class="modal-header"  style='font-size:24px; background-color:whitesmoke;'>
                    <span class="align-self-center modal-title">Download File</span>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                </div>

                <div class="modal-body text-left">
                    <table  style='margin-left:auto; margin-right:auto;'>
                        <tbody>
                            <tr>
                                <td  style='padding-left:5px; padding-right:20px;'>Name:</td>
                                <td><b>{{ file.name }}</b></td>
                            </tr>
                            <tr>
                                <td  style='padding-left:5px; padding-right:20px;'>Size:</td>
                                <td><b>{{ (file.size / (1024 * 1024)).toFixed(2) }} MB</b></td>
                            </tr>
                            <tr>
                                <td  style='padding-left:5px; padding-right:20px;'>Created:</td>
                                <td v-if="file.timestamp"><b>{{ file.timestamp | moment("HH:mm:ss, Do MMM YYYY") }}</b></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="modal-footer">
                    <a :href="axios.defaults.baseURL + 'api/files/' + file.code + '/download?api_token=' + api_token" 
                       target="_blank"
                       class="ml-auto btn btn-success">Download</a>
                    <button type="button" class="ml-auto btn btn-primary" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "File_Download",
        props: [
            'file'
        ],
        components: {},

        computed: {},
        created() {},
        mounted() {},

        data() {
            return {
                api_token:  localStorage.getItem('api_token'),
            };
        },

        methods: {
            close() {
                this.$emit('close');
            }
        },
    };
</script>
<style>
</style>